 import React, { useEffect, useState, useRef } from 'react'
import { DataCollectionModal, DataCollectionState } from '../add-new-data-collection/new-data-collection-state';
import * as collectionService from '../../../services/data-collection.service';
import * as connectionService from '../../../services/data-source.service';
import BasicInformationController from '../add-new-data-collection/basic-information/basic-information-controller';
import ColumnSelectionPopup from '../../../components/data-collections/column-selection-popup/column-selection-popup';
import { AppEnum } from '../../../constants/app-enum';
import _ from 'lodash';
import { RestServiceConstants } from '../../../constants/rest-service-constant';
import { toast } from 'react-toastify';
import { DynamicList } from '../../connections/variables/variables-Popup';
import { UpdateUserModel } from '../../connections/variables/variables-Popup';
import { authorizeAgain, getToken } from '../../../services/authorize-again-service';
import { checkOtherParams, filterCollectionParams } from '../DataVisualizer/data-visualizer-controller';
import { DateParseVariable } from '../../../constants/date-parse-variable';
import { getEquivalentPriorityDataType } from '../add-new-data-collection/select-columns/datatypes-equivalent-map';
import { findDisplayFormat } from '../add-new-data-collection/add-new-data-collection';
import { isNullOrEmpty } from '../../../services/data-source-validation';
import { formatDisplayName } from '../utils/template-collection-parameter';
import { MergeTestData } from '../../../services/merge-collection-test-data-service';
import { getAllScript } from '../../../services/data-script.service';
import { defaultJavaScriptEditorValue } from '../column-selection/cloud-data-script/cloud-data-script-controller';
import { updateParameterValues as cloudUpdateParameterValues } from "../utils/template-collection-parameter";
import { useLocation, useNavigate } from 'react-router-dom';
import { setPluginChange } from '../../../services/authCallback-service';
import { closeIFrameDialog } from '../../../components/asheetPlugin/utils2/common-code';

export default function NativeDataVisualizerController(props){

    const  { excelDataState, setExcelDataState, closeWindowOnPopupClose, collectionUId } = props;

    const [state, setState] = useState(new DataCollectionState());
    const [selectedConnection, setSelectedConnection] = useState(null);
    const [isOpenInDialog,setIsOpenInDialog] = useState(props.showNativeDataVisualizer);
    const [selectedSearchButton, setSelectedSearchButton] = useState(0);
    const [isSearchOptionsAvailable, setIsSearchOptionsAvailable] = useState(false);
    const [searchOptionsParameters, setSearchOptionsParameters] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [columnsList, setColumnList] = useState([]);
    const [isColumnOrderChanged, setIsColumnOrderChanged] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [preview, setPreview] = useState(false);
    const searchInputRef = useRef(null);
    const [searchValue, setSearchValue] = useState('');
    const [filterColumnsList, setFilterColumnsList] = useState([]);
    const [openConnectionPopup, setOpenConnectionPopup] = useState(false);
    const [stateConnectionParameter, setStateConnectionParameter] = useState(false);
    const [isAuthorizeAgain, setIsAuthorizeAgain] = useState(false);
    const [nativeCollectionParameterResponse,SetNativeCollectionParameterResponse] = useState(false);
    const [restSchemaList,setRestSchemaList] = useState([]);
    const [isRestSchemaAvailable,setIsRestSchemaAvailable] = useState(false);
    const [isDynamicListValues, setIsDynamicListValues] = useState(
        new DynamicList()
      );
    const [variableUId,setVariableUId] = useState("");
    const [manualColumns,setManualColumns] = useState([]);
    const dateParser = new DateParseVariable();

    const [openPopup, setOpenPopup] = useState(false);        
    const [customColumn, setCustomColumn] = useState();
    const [datatypeDisplayFormate, setDatatypeDisplayFormate] = useState();
    const [prioritizeEquivalentDataTypes, setPrioritizeEquivalentDataTypes] = useState();
    const [mergedCollectionsData, setMergedCollectionsData] = useState([]);
    const [isMergeDataPopupVisible, setIsMergeDataPopupVisible] = useState(false);
    const [mergeDataPopupMessage, setMergeDataPopupMessage] = useState([]);
    const isMergeCancelledRef = useRef(false);
    const [preDefinedScriptsData, setPreDefinedScriptsData] = useState();
    const [openDataScriptPopup, setOpenDataScriptPopup] = useState(false);
    const [cloudDataScriptType, setCloudDataScriptType] = useState(null);
    const [pluginParameterState, setPluginParameterState] = useState(excelDataState ?? {});
    const [testedData, setTestedData] = useState({
        transformedData: [],
        transformedDataColunmsKey: [],
        styleTransformedData: [],
        styleTransformedDataColunmsKey: [],
    });
    const [muiDialog, setMuiDialog] = useState(false);
    const [queryState, setQueryState] = useState();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        storeQueryDetails(urlParams);
    }, [])

    const handleQueryDetails = (urlParams) => {
        const isMergeCollectionFromExcel = urlParams.get('isMergeCollectionFromExcel');
        const isGoogleDriveFromExcel = urlParams.get('isGoogleDriveFromExcel');

        const isMergeCollectionFromExcelResult = isMergeCollectionFromExcel?.toLowerCase() == "true" ? true : false;
        const isGoogleDriveFromExcelResult = isGoogleDriveFromExcel?.toLowerCase() == "true" ? true : false;

        if (isMergeCollectionFromExcelResult || isGoogleDriveFromExcelResult) {
            const collectionUId = urlParams.get('collectionUId');
            const data = urlParams.get('data');
            const parameters = urlParams.get('Parameters');
            const isEditMode = urlParams.get('isEditMode');
            const isNativeVisualizer = urlParams.get('isNativeVisualizer');
    
            setPluginParameterState(
                {
                    collectionUId: collectionUId,
                    isMergeCollectionFromExcel: isMergeCollectionFromExcelResult,
                    data: data,
                    parameters: parameters,
                    isEditMode: isEditMode?.toLowerCase() == "true" ? true : false,

                    isGoogleDriveFromExcel: isGoogleDriveFromExcelResult,
                    isNativeVisualizer: isNativeVisualizer?.toLowerCase() == "true" ? true : false,
                    isCommandFromExcel: (isMergeCollectionFromExcelResult || isGoogleDriveFromExcelResult),
                }
            )
        }
    }

    const storeQueryDetails = (urlParams) => {

        const closeWindowOnPopupClose = urlParams.get('closeWindowOnPopupClose');
        const collectionUId = urlParams.get('collectionUId');
        const accessToken = urlParams.get('AccessToken');
        const refreshToken = urlParams.get('RefreshToken');
        const aSTenantUId = urlParams.get('ASTenantUId');
        const isForDataCollections = urlParams.get('isForDataCollections');
        handleQueryDetails(urlParams);
        setQueryState(
            {
                CollectionUId: collectionUId,
                CloseWindowOnPopupClose: closeWindowOnPopupClose?.toLowerCase() == "true" ? true : false,
                isForDataCollections: isForDataCollections
            }
        )

        if ((accessToken != null && refreshToken != null && aSTenantUId != null)) {

            localStorage.setItem("refresh_token", refreshToken);
            localStorage.setItem("token", accessToken);
            localStorage.setItem("ASTenantId", aSTenantUId);

            urlParams.delete('closeWindowOnPopupClose');
            urlParams.delete('AccessToken');
            urlParams.delete('RefreshToken');
            urlParams.delete('ASTenantUId');
            urlParams.delete('isForDataCollections');
            urlParams.delete('isMergeCollectionFromExcel');
            urlParams.delete('collectionUId');
            urlParams.delete('data');
            urlParams.delete('parameters');
            urlParams.delete('isEditMode');
            urlParams.delete('redirectUrl');

            urlParams.delete('isGoogleDriveFromExcel');
            urlParams.delete('isNativeVisualizer');

            navigate(`${location.pathname}?${urlParams.toString()}`, { replace: true });
        }
    }

    useEffect(() => {
        let value = !isSearchOptionsAvailable ? 1 : 0;
        setSelectedSearchButton(value);
    }, [isSearchOptionsAvailable])

    useEffect(() => {
        setIsLoading(true);
        const collectionUId = queryState?.CollectionUId || props.collectionUId;
        if (collectionUId) {
            getCollectionDetails(collectionUId);
        }
    }, [queryState, props.collectionUId]);

    useEffect(()=>{
        setPrioritizeEquivalentDataTypes(getEquivalentPriorityDataType(state?.displayFormatList));
    },[state?.displayFormatList])

    useEffect(() => {
        if (state?.connectionUId) {
            getCurrentConnectionDetails(state.connectionUId);
            getDisplayFormatList();
        }
    }, [state?.connectionUId])


    useEffect(()=>{
        if(selectedConnection != null && state?.sysCollectionTypeId === AppEnum.SysCollectionTypeId.REST){
            executeData();
        }
    },[selectedConnection])

    useEffect(() =>{
        if(nativeCollectionParameterResponse){
            if(state?.sysCollectionTypeId !== AppEnum.SysCollectionTypeId.REST || state?.hasMergeCollections){
                getColumnSchema(state,formatColumList);
            
            }
        }
    },[state?.uId, nativeCollectionParameterResponse]);

    useEffect(() => {
        if (state?.collectionColumnSchema && state?.collectionColumnSchema.length > 0 && !isColumnOrderChanged && state?.sysCollectionTypeId !== AppEnum.SysCollectionTypeId.REST) {
            executeData(false);
        }
    }, [columnsList])

    useEffect(()=>{
        if(isRestSchemaAvailable && !state?.dynamicColumnSchema){
            formatColumList(restSchemaList);
        }
    },[isRestSchemaAvailable])

    useEffect(() => {
            dataAfterTransformation(state?.testedDataList);
    }, [state?.testedDataList])

    useEffect(() => {

        if (state?.collectionColumns.length > 0 && props.collectionUId && state.testedDataTransformedColumneKeys.length === 0) {
            const updatedColumns = state?.collectionColumns.map(column => ({
                ...column,
                ColumnDataType: state?.displayFormatList?.filter(i => i.sysDataTypeId === column?.dataType)[0]?.dataBaseDataType,
                isSelected: true
            }));

            setState(prevState => ({
                ...prevState,
                columnSchemaList: updatedColumns
            }));
        }

        //removing colunms whic are not present in table after transformation on update.
        if (state?.columnSchemaList && state?.collectionColumns && props.collectionUId && state?.testedDataTransformedColumneKeys.length > 0 && !state?.hasMergeCollections) {
            const filteredColumnsList = state?.columnSchemaList.filter(column => (state?.testedDataTransformedColumneKeys.includes(column.columnName) || column?.isManuallyCreated));
            const filteredColumns = state?.collectionColumns.filter(column => (state?.testedDataTransformedColumneKeys.includes(column.columnName) || column?.isManuallyCreated));
            setState((prevState) => { return { ...prevState, columnSchemaList: filteredColumnsList } });
            setState((prevState) => { return { ...prevState, collectionColumns: filteredColumns } });
            if(state?.sysCollectionTypeId === AppEnum.SysCollectionTypeId.REST){
                setIsRestSchemaAvailable(true);
            }
            
        }
    }, [state?.testedDataTransformedColumneKeys]);

    useEffect(() => {
        if (state?.hasMergeCollections && state?.collectionUIdsToMerge && mergedCollectionsData?.length == 0){
            getMergedCollectionDetails()
        }
        else if(state?.hasMergeCollections){
            getCollectionScripts();
        }
    }, [state?.hasMergeCollections])

    useEffect(() => {
        if (state?.hasMergeCollections) {
            if (state.restBody) {
                setState((prevState) => { return {...prevState, selectedScriptType: AppEnum.MergeCollection.SQL}})
            } 
            else if (state.mergeScript) {
                setState((prevState) => { return {...prevState, selectedScriptType: AppEnum.MergeCollection.Custom_Script}})
            } 
            else if (state.dataTransformationScriptId) {
                setState((prevState) => { return {...prevState, selectedScriptType: AppEnum.MergeCollection.Predefined_Script}})
            } 
        }
    }, [state?.hasMergeCollections, state?.hasMergeCollections, state?.mergeScript, state?.dataTransformationScriptId]); 

    useEffect(() => {
        if (state.testedDataList.length > 0) {
            // if (( (state?.cloudDataTransformationScript != null && state?.cloudDataTransformationScript !== defaultJavaScriptEditorValue) || state?.dataTransformationScriptId )){
            //     if (testedData?.transformedData?.length == 0) {
            //         handleTestScript(null, AppEnum.DataScript.dataTransformationScript)
            //     }
            // }
            if (( (state?.dataStylingScript != null && state?.dataStylingScript !== defaultJavaScriptEditorValue) || state?.dataStylingScriptId)) {
                // if (testedData?.styleTransformedData?.length == 0) {
                    handleTestScript(null, AppEnum.DataScript.dataStylingScript)
                // }
            }
        }
    }, [state.testedDataList])  

    const getCollectionDetails = (collectionUId) => {

        collectionService.getCollectionDetails(collectionUId)
            .then(async (response) => {
                if (response?.data) {
                    let prevCollection = response?.data;
                    if (prevCollection) {

                        if (
                            prevCollection.isCollectionAsDataSource &&
                            prevCollection?.variable != null
                          ) {
                            setVariableUId(prevCollection?.variable?.uId);
                            const parsedData = JSON.parse(
                              prevCollection?.variable?.complexTypeValue
                            );
                            setIsDynamicListValues(parsedData);                            
                        }
                        prevCollection["collectionColumns"] = prevCollection.collectionColumns?.filter(i => i.inActive != true);

                        setState((prevState) => {

                            return {
                                ...prevState,
                                connectionUId: prevCollection.connectionUId,
                                uId: prevCollection.uId,
                                sysCollectionTypeId: prevCollection.sysCollectionTypeId,
                                sysConnectionTypeId: prevCollection.sysConnectionTypeId,
                                sysCollectionSubTypeId: prevCollection.sysCollectionSubTypeId,
                                childGroupName: prevCollection.childGroupName,
                                groupName: prevCollection.groupName,
                                sourceName: prevCollection.sourceName,
                                sourceNamePart2: prevCollection.sourceNamePart2,
                                sourceNamePart4: prevCollection.sourceNamePart4,
                                isCollectionAsDataSource: prevCollection.isCollectionAsDataSource,
                                hasPrintableCollection: prevCollection.hasPrintableCollection,
                                collectionColumns: prevCollection.collectionColumns,
                                collectionParameters: prevCollection.collectionParameters,
                                collectionFilterColumns: prevCollection.collectionFilterColumns,
                                name: prevCollection.name,
                                categoryUId: prevCollection.categoryUId,
                                restSendAsCD: prevCollection.restSendAsCD,
                                restDataTransformationScript: prevCollection.restDataTransformationScript,
                                restBody: prevCollection.restBody,
                                restRequestMethod: prevCollection.restRequestMethod,
                                prevCollection: prevCollection,
                                basicInfoError: null,
                                templateCollectionId: prevCollection.templateCollectionId,
                                isFilterSupported: prevCollection.isFilterSupported,
                                isSortSupported: prevCollection.isSortSupported,
                                isPagingSupported: prevCollection.isPagingSupported,
                                areAllFieldsFilterable: prevCollection.areAllFieldsFilterable,
                                areAllFieldsSortable: prevCollection.areAllFieldsSortable,
                                columnApiEndpoint: prevCollection.columnApiEndpoint,
                                variableId: prevCollection.variableId,
                                returnRawData: prevCollection.returnRawData,
                                hasMergeCollections: prevCollection.hasMergeCollections,
                                collectionUIdsToMerge: prevCollection.collectionUIdsToMerge,
                                combineMergedParameters: prevCollection.combineMergedParameters,
                                mergeScript: prevCollection.mergeScript,
                                useTemplateConnection: prevCollection.useTemplateConnection,
                                mergeScript: prevCollection.mergeScript,
                                dataStylingScript: prevCollection.dataStylingScript,
                                dataTransformationScriptId: prevCollection.dataTransformationScriptId,
                                dataStylingScriptId: prevCollection.dataStylingScriptId,
                                flattenLikeSql: prevCollection?.flattenLikeSql || false,
                                excludedProperties: prevCollection?.excludedProperties || "",
                                gptPrompt: prevCollection.gptPrompt || "",
                            }
                        })

                        const manuallyCreatedItems = prevCollection?.collectionColumns.filter(column => column.isManuallyCreated);

                        if(manuallyCreatedItems.length > 0){
                            setManualColumns(manuallyCreatedItems);
                        }

                        if(prevCollection?.restDataTransformationScript){
                            setState((prevState) => { return { ...prevState, restDataTransformationScript: prevCollection?.restDataTransformationScript } });
                        }

                        if (prevCollection.hasMergeCollections) {
                            prevCollection["collectionParameters"]= await getMergedCollectionsParameters(prevCollection.collectionUIdsToMerge, prevCollection?.combineMergedParameters);
                        }

                        if (prevCollection.collectionParameters?.length > 0){
                            const hasOtherParams = checkOtherParams(prevCollection?.collectionParameters);

                              if (hasOtherParams){
                                prevCollection["collectionParameters"] = filterCollectionParams(prevCollection?.collectionParameters)
                                let updatedParams = prevCollection.hasMergeCollections ? prevCollection.collectionParameters : updateParameterValues(prevCollection.collectionParameters);
                                setIsSearchOptionsAvailable(true);
                                setSearchOptionsParameters(updatedParams);
                              }
                              else{
                                setIsSearchOptionsAvailable(false);
                                setSearchOptionsParameters([]);
                              }
                        }
                        else{
                            setIsSearchOptionsAvailable(false);
                            setSearchOptionsParameters([]);
                        }

                        SetNativeCollectionParameterResponse(true);
  
                        if (prevCollection.isTemplateCollection && prevCollection.isInheritCollection) {
                            setState((prevState) => { return { ...prevState, uId: null } });
                        }
                        getCollectionTypeList(prevCollection.sysCollectionTypeId);
                    }
                }
                else if (response?.hasError)
                    setState((prevState) => { return { ...prevState, basicInfoError: response.errorMessage } });
            })
    }

  

    const getColumnSchema = async (prevCollection, callback = null) => {
        setIsLoading(true);

        let dataCollectionModal;

        if (prevCollection) {
            dataCollectionModal = getDataCollectionModal(prevCollection);
        }
        else {
            dataCollectionModal = getDataCollectionModal(null);
        }

        const response = await collectionService.getColumnSchema(dataCollectionModal);

        if (response) {
            if (response?.hasError) {
                setState((prevState) => { return { ...prevState, columnSchemaError: response?.errorMessage, columnSchemaList: [] } });
                setIsLoading(false);
            }
            else {
                setState((prevState) => { return { ...prevState, collectionColumnSchema: response?.data?.data } });

                if (callback != null) {
                    callback(response?.data?.data);
                }
                setIsLoading(false);
            }
        }
    }

    const formatColumList = (data, isDynamicColumns) => {
        if (data) {

            const mapManualColumns =  Object.keys(manualColumns).map(key  => ({
                columnName: manualColumns[key].columnName,
                columnDataType: manualColumns[key].columnDataType,
                displayName: manualColumns[key].displayName
            }));

            if(mapManualColumns.length > 0){
                data = data.concat(mapManualColumns);
            }

            var columns = data?.map((i) => {
                let columnMap = state?.collectionColumns?.find(c => c.columnName == i.columnName);

                return {
                    columnName: columnMap?.columnName ? columnMap?.columnName : i.columnName ,
                    displayName: columnMap?.displayName ? columnMap?.displayName : i.displayName,
                    displayFormat:  columnMap?.displayFormat ? columnMap?.displayFormat : i.displayFormat,
                    isFilterable: columnMap?.isFilterable ? columnMap?.isFilterable : i.isFilterable,
                    isSortable:  columnMap?.isSortable ? columnMap?.isSortable : i.isSortable,
                    isDefault:  columnMap?.isDefault ? columnMap?.isDefault : i.isDefault,
                    isManuallyCreated: columnMap?.isManuallyCreated ? columnMap?.isManuallyCreated : i.isManuallyCreated,
                    isSelected: (state?.collectionColumns?.find(c => c.columnName == i.columnName) || isDynamicColumns) ? true : false,
                    dataTypeName:  columnMap?.dataTypeName ? columnMap?.dataTypeName : i.columnDataType ? i.columnDataType : i.dataTypeName,
                    isMultiSelect:  columnMap?.isMultiSelect ? columnMap?.isMultiSelect : i.isMultiSelect,
                    options: columnMap?.options ? columnMap?.options : i.options,
                    notQuerable:  columnMap?.notQuerable ? columnMap?.notQuerable : i.notQuerable,
                    displayOrder : state?.collectionColumns?.length > 0 ? state?.collectionColumns?.find(c => c.columnName == i.columnName)?.displayOrder : 0
                }
            })?.filter(Boolean); 
            setState((prevState) => { return { ...prevState, collectionColumnSchema: columns } });
            const sortedList = _.orderBy(columns,['isSelected', (col) => col?.displayName?.toLowerCase()],['desc', 'asc']);

            setIsColumnOrderChanged(false);
            setColumnList(sortedList);
        }
        return [];
    }


    const getDataCollectionModal = (prevCollection) => {
        let dataCollectionModal = new DataCollectionModal();
        let collection;
        if (prevCollection)
            collection = prevCollection;
        else
            collection = state;

        dataCollectionModal.connectionUId = collection.connectionUId;
        dataCollectionModal.groupName = collection.groupName;
        dataCollectionModal.childGroupName = collection.childGroupName;
        dataCollectionModal.name = collection.name;
        dataCollectionModal.sysCollectionTypeId = collection.sysCollectionTypeId;
        dataCollectionModal.sysConnectionTypeId = collection.sysConnectionTypeId;
        dataCollectionModal.sysCollectionSubTypeId = collection.sysCollectionSubTypeId;
        dataCollectionModal.sourceName = collection.sourceName;
        dataCollectionModal.sourceNamePart2 = collection.sourceNamePart2;
        dataCollectionModal.sourceNamePart4 = collection.sourceNamePart4;
        dataCollectionModal.categoryUId = collection.categoryUId;
        dataCollectionModal.columnSchema = collection.columnSchema;
        dataCollectionModal.isCollectionAsDataSource = collection.isCollectionAsDataSource;
        dataCollectionModal.hasPrintableCollection = collection.hasPrintableCollection;
        dataCollectionModal.collectionParameters = collection.collectionParameters;
        dataCollectionModal.collectionFilterColumns = collection.collectionFilterColumns;
        dataCollectionModal.collectionColumns = collection.collectionColumns;
        dataCollectionModal.uId = collection.uId;
        dataCollectionModal.restRequestMethod = collection.restRequestMethod ? collection.restRequestMethod : state.restRequestMethod;
        dataCollectionModal.restBody = collection.restBody ? collection.restBody : state.restBody;
        dataCollectionModal.restSendAsCD = collection.restSendAsCD ? collection.restSendAsCD : state.restSendAsCD;
        dataCollectionModal.restDataTransformationScript = collection.restDataTransformationScript ? collection.restDataTransformationScript : state.restDataTransformationScript;
        dataCollectionModal.templateCollectionId = collection?.templateCollectionId;
        dataCollectionModal.sourceNamePart2 = collection.sourceNamePart2;
        dataCollectionModal.isFilterSupported = collection?.isFilterSupported;
        dataCollectionModal.isSortSupported = collection?.isSortSupported;
        dataCollectionModal.isPagingSupported = collection?.isPagingSupported;
        dataCollectionModal.areAllFieldsFilterable = collection?.areAllFieldsFilterable;
        dataCollectionModal.areAllFieldsSortable = collection?.areAllFieldsSortable;
        dataCollectionModal.columnApiEndpoint = collection?.columnApiEndpoint;
        dataCollectionModal.variableId = collection?.variableId;
        dataCollectionModal.returnRawData = collection.returnRawData;
        dataCollectionModal.hasMergeCollections = collection.hasMergeCollections;
        dataCollectionModal.collectionUIdsToMerge = collection.collectionUIdsToMerge;
        dataCollectionModal.useTemplateConnection = collection.useTemplateConnection;
        dataCollectionModal.combineMergedParameters = collection.combineMergedParameters;
        dataCollectionModal.dataStylingScript = collection.dataStylingScript;
        dataCollectionModal.dataStylingScriptId = collection.dataStylingScriptId;
        dataCollectionModal.dataTransformationScriptId = collection.dataTransformationScriptId;
        dataCollectionModal.mergeScript = collection.mergeScript;
        dataCollectionModal.flattenLikeSql = collection?.flattenLikeSql || false;
        dataCollectionModal.excludedProperties = collection?.excludedProperties || "";
        dataCollectionModal.gptPrompt = collection.gptPrompt;

        return dataCollectionModal;
    }

    const getCollectionTypeList = (sysConnectionTypeId) => {

        collectionService.getCollectionTypeList(sysConnectionTypeId)
            .then((response) => {
                if (response?.data)
                    setState((prevState) => { return { ...prevState, collectionTypeList: response.data } });
            })
    }

    const resetErrorMessages = () => {
        setState((prevState) => {
            return {
                ...prevState, basicInfoError: null
                , columnSchemaError: null, testCollectionError: null
            }
        })
    }

    const getCurrentConnectionDetails = (connectionUId) => {
        connectionService.getDataSourceByUID(connectionUId).then((res) => {
            if (res?.data) {
                setSelectedConnection(res.data);
            }
        });
    }

    const handleChangeObject = (isCrossIconClick) => {
        setIsOpenInDialog(false);
        props.setShowNativeDataVisualizer(false);

        if (pluginParameterState?.isCommandFromExcel && window.chrome && window.chrome.webview && isCrossIconClick) { //for excel popup close on mergeCollection
            window.chrome?.webview?.postMessage('close_window')
        }
    }

    const getNativeCollectionParameters = async  (collectionUId) => {

        collectionService.getCollectionDetails(collectionUId)
            .then((response) => {
                if (response?.data) {
                    let prevCollection = response?.data;
                    if (prevCollection) {

                        if(prevCollection?.restDataTransformationScript){
                            setState((prevState) => { return { ...prevState, restDataTransformationScript: prevCollection?.restDataTransformationScript } });
                        }

                        if (prevCollection.collectionParameters?.length > 0){
                            const hasOtherParams = prevCollection?.collectionParameters?.some(
                                param => param.parameterTypeCD.toLowerCase() !== "fixed hidden"
                              );
                              if (hasOtherParams){
                                  let updatedParams = updateParameterValues(prevCollection.collectionParameters);
                                  setIsSearchOptionsAvailable(true);
                                  setSearchOptionsParameters(updatedParams);
                              }
                              else{
                                setIsSearchOptionsAvailable(false);
                                setSearchOptionsParameters([]);
                              }
                        }
                        else{
                            setIsSearchOptionsAvailable(false);
                            setSearchOptionsParameters([]);
                        }

                        SetNativeCollectionParameterResponse(true);
                    }
                }
            })
        
        // return false;
    }

    const updateParameterValues = (params) => {
        return params.map(param => {
            if (param.sysDataTypeId == AppEnum.DataTypeId.DynamicList && param?.complexTypeValue) {
                    const complexType = JSON.parse(param.complexTypeValue);
                    param.parameterValue = complexType?.DefaultValue
                
            }
            else if (param.sysDataTypeId == AppEnum.DataTypeId.List && param?.complexTypeValue) {
                    const complexTypeArray = JSON.parse(param.complexTypeValue);
                    const defaultItem = complexTypeArray?.find(item => item.Default === true);
                    param.parameterValue = defaultItem.Value;
                }
            else if(param.parseAtClientSide && param.sysDataTypeId === AppEnum.DataTypeId.Date){
                param.parameterValue = dateParser.parseVariable(param.defaultValue);
            }
            else {
                if(!param.variableUId && !param.isSystemDefineVariable){
                    param.parameterValue = param.defaultValue;
                }
            }

            if (pluginParameterState?.isCommandFromExcel && pluginParameterState?.parameters) {
                let excelParameters = JSON.parse(pluginParameterState?.parameters);
                if (excelParameters) {
                    if (pluginParameterState?.isMergeCollectionFromExcel) {
                        let paramValue =  excelParameters?.find(i => i.Id == param?.id && i.ChildCollectionUId == param?.childCollectionUId);
                        if (paramValue) {
                            param.parameterValue = excelParameters?.find(i => i.Id == param?.id && i.ChildCollectionUId == param?.childCollectionUId)?.ParameterValue;
                        }
                    }
                    else {
                        let paramValue =  excelParameters?.find(i => i.Id == param?.id);
                        if (paramValue) {
                            param.parameterValue = excelParameters?.find(i => i.Id == param?.id)?.ParameterValue;
                        }
                    }
                }
            }

            return param;
        });
    };

    const executeData = async (previewTrue = false) => {

        if (preview && !previewTrue) {
            return;
        }
        else if (preview && previewTrue) {
            setPreview(false);
        }

        setFilterColumnsList([]);
        setSearchValue('');
        if (searchInputRef?.current){
            searchInputRef.current.value = '';
        }

       
        setIsLoading(true);

        setState((prevState) => { return { ...prevState, isTestingConnection: true } });
        resetErrorMessages();

        let testDataCollectionModal = {
            connectionUId: state.connectionUId,
            sysCollectionTypeId: state.sysCollectionTypeId,
            sourceName: state.sourceName,
            restRequestMethod: state.restRequestMethod,
            restRequestIsAsync: true,
            restSendAsCD: state.restSendAsCD,
            collectionParameters: state.collectionParameters,
            collectionColumns: state.collectionColumnSchema ? state.collectionColumnSchema : state.collectionColumns,
            uId: state.uId,
            returnFlatternData: state.sysCollectionTypeId === 7 ? !(state.returnRawData) : false,
            sourceNamePart4: state.sourceNamePart4,
            templateCollectionId: state.templateCollectionId,
            collectionFilters: [],
            collectionSorts: [],
            collectionLimit: null,
            restDataTransformationScript : state?.restDataTransformationScript,
            returnRawData : state?.returnRawData,
            restBody : state.restBody,
            hasMergeCollections: state?.hasMergeCollections,
            collectionUIdsToMerge: state?.collectionUIdsToMerge,
            mergeScript: state?.mergeScript,
            selectedScriptType: state?.selectedScriptType,
            dataStylingScript: state?.dataStylingScript,
            dataStylingScriptId: state?.dataStylingScriptId,
            dataTransformationScriptId: state?.dataTransformationScriptId,
            columnApiEndpoint : state?.columnApiEndpoint,
            connectionId : selectedConnection?.id,
            combineMergedParameters : state?.combineMergedParameters,
            flattenLikeSql: state?.flattenLikeSql || false,
            excludedProperties: state?.excludedProperties || ""
        }

        if (testDataCollectionModal.hasMergeCollections && Array.isArray(testDataCollectionModal.collectionUIdsToMerge)) {
            let preDefinedScripts = preDefinedScriptsData;
            if (!preDefinedScriptsData) {
                preDefinedScripts = await getCollectionScripts();
            }
            const response = await MergeTestData(testDataCollectionModal, setState, setIsAuthorizeAgain, setIsMergeDataPopupVisible,
                setMergedCollectionsData, setMergeDataPopupMessage, null, isMergeCancelledRef, setIsLoading, preDefinedScripts);

            handleSendDataToExcel(response);
            setIsLoading(false);
        } else {
            testDataCollection(testDataCollectionModal,false);
        }
    };

    const executedData = async (isRunAndSave, isExecutingSearchOptionsForMergeCollections) => {

        setIsLoading(true);

        setState((prevState) => { return { ...prevState, isTestingConnection: true } });
        resetErrorMessages();

        let testDataCollectionModal = {
            connectionUId: state.connectionUId,
            sysCollectionTypeId: state.sysCollectionTypeId,
            sourceName: state.sourceName,
            restRequestMethod: state.restRequestMethod ,
            restRequestIsAsync: true,
            restSendAsCD: state.restSendAsCD,
            collectionParameters: searchOptionsParameters,
            collectionColumns: state.collectionColumnSchema ? state.collectionColumnSchema : state.collectionColumns,
            uId: state.uId,
            returnFlatternData: state.sysCollectionTypeId === 7 ? !(state.returnRawData) : false,
            sourceNamePart4: state.sourceNamePart4,
            templateCollectionId: state.templateCollectionId,
            collectionFilters: [],
            collectionSorts: [],
            collectionLimit: null,
            restDataTransformationScript : state?.restDataTransformationScript,
            returnRawData : state.returnRawData,
            restBody : state.restBody,
            hasMergeCollections: state?.hasMergeCollections,
            collectionUIdsToMerge: state?.collectionUIdsToMerge,
            mergeScript: state?.mergeScript,
            selectedScriptType: state?.selectedScriptType,
            dataStylingScript: state?.dataStylingScript,
            dataStylingScriptId: state?.dataStylingScriptId,
            dataTransformationScriptId: state?.dataTransformationScriptId,
            columnApiEndpoint : state?.columnApiEndpoint,
            connectionId : selectedConnection?.id,
            combineMergedParameters : state?.combineMergedParameters,
            flattenLikeSql: state?.flattenLikeSql || false,
            excludedProperties: state?.excludedProperties || ""
        }

        if (testDataCollectionModal.hasMergeCollections && Array.isArray(testDataCollectionModal.collectionUIdsToMerge)) {
            let preDefinedScripts = preDefinedScriptsData;
            if (!preDefinedScriptsData) {
                preDefinedScripts = await getCollectionScripts();
            }
            const response = await MergeTestData(testDataCollectionModal, setState, setIsAuthorizeAgain, setIsMergeDataPopupVisible,
                setMergedCollectionsData, setMergeDataPopupMessage, null, isMergeCancelledRef, setIsLoading, preDefinedScripts, true, isExecutingSearchOptionsForMergeCollections);

            handleSendDataToExcel(response, isRunAndSave);
            setIsLoading(false);
        } else {
            testDataCollection(testDataCollectionModal,true, isRunAndSave);
        }
    };

    const getDisplayFormatList = () => {

        collectionService.getDisplayFormats()
            .then((response) => {

                if (response?.hasError)
                    setState((prevState) => { return { ...prevState, columnSchemaError: response.errorMessage } });

                else if (response?.data) {
                    setState((prevState) => { return { ...prevState, displayFormatList: response?.data } });
                }
            })
    }

    const handleSearchOptionsButtonClick = (index) => {
        setSelectedSearchButton(index);
    };

    //it tests the collection
     const testDataCollection = async  (testDataCollectionModal,searchButtonRefreshPreviewClicked, isRunAndSave) => {

        setState((prevState) => { return { ...prevState, isTestingConnection: true, testedDataList: [], testedDataColumnKeys:[] } });
        resetErrorMessages();

        const response = await collectionService.executedDataCollection(testDataCollectionModal);
        if(response){
            let errorMessage = '';
                if (response?.hasError){
                    errorMessage = response?.errorMessage;
                    setState((prevState) => { return { ...prevState, nativeCollectionError : errorMessage}});
                    setIsLoading(false);
                    toast.error(errorMessage);
                } 
                else if (response?.data?.errorMessage && response?.data?.data == null){
                    errorMessage = response?.data?.errorMessage;
                    setState((prevState) => { return { ...prevState, nativeCollectionError : errorMessage}});
                    setIsLoading(false);
                    toast.error(errorMessage);
                }
                else if(response?.data?.data == null && !response?.hasError && !response?.data?.errorMessage){
                    errorMessage = "The collection was tested successfully but data is not available for the given parameters.";
                    toast.error(errorMessage);
                }
                else if (response?.data?.data) {
                    if(response?.data?.statusCode == "Unauthorized"){
                            var authType = selectedConnection?.parameters.filter((i) => i.parameterType == RestServiceConstants.AUTH_TYPE)[0]?.parameterValue;
                            var grantType = selectedConnection?.parameters.filter((i) => i.parameterType == RestServiceConstants.OAUTH2_INPUTS.GRANT_TYPE)[0]?.parameterValue;
                            if(authType == AppEnum.RestConnnectionTypes.OAuth_2 && (grantType == "authorization_code" || grantType == "authorization_code_with_pkce")){
                                errorMessage = "Unauthorized";
                            }
                            setState((prevState) => { return { ...prevState, nativeCollectionError : errorMessage}});
                            setIsAuthorizeAgain(true);
                            setIsLoading(false);
                    }
                    else if(response?.data?.statusCode == "Forbidden"){
                        errorMessage = response?.data?.errorMessage;
                        setState((prevState) => { return { ...prevState, nativeCollectionError : errorMessage}});
                        setIsLoading(false);
                        toast.error(errorMessage);
                    }
                    else if(response?.data?.data?.length === 0 || Object.keys(response?.data?.data).length === 0){
                        setIsAuthorizeAgain(false);
                        errorMessage = 'The collection was tested successfully but data is not available for the given parameters.';
                        toast.success(errorMessage);
                    }
                    else{
                        setIsAuthorizeAgain(false);
                        errorMessage = 'The collection was tested successfully.';

                        let testedDataColumnKeys = null;
                        let finalData;

                        if(state.returnRawData && !Array.isArray(response?.data?.data)){
                            let rawResponse = [];
                            rawResponse.push(response?.data?.data);
                            finalData = rawResponse;
                        }else{
                            finalData = response?.data?.data;
                        }

                        if (response?.data?.dynamicColumnSchema) {
                            formatColumList(response?.data?.dynamicColumnSchema, true)
                        }

                        if(finalData){
                            try{
    
                                if(!state.returnRawData){
                                    
                                        if (testDataCollectionModal.sysCollectionTypeId == 7){

                                            finalData = Object.keys(finalData).reduce((acc, key) => {
                                                finalData[key].forEach((value, index) => {
                                                if (!acc[index]) {
                                                    acc[index] = {};
                                                }
                                                // Skip rows with null values
                                                // if (value !== null) {
                                                    acc[index][key] = value;
                                                //}
                                                });
                                                return acc;
                                            }, []);
                                            
                                            testedDataColumnKeys = Object.keys(finalData[0] || {});
                                        }
                                        else {
                                            let maxPropsObject = {};
                                            let maxPropsCount = 0;

                                            finalData.forEach(obj => {
                                                const numProps = Object.keys(obj).length;
                                                if (numProps > maxPropsCount) {
                                                    maxPropsCount = numProps;
                                                    maxPropsObject = obj;
                                                }
                                            });
            
                                            testedDataColumnKeys = maxPropsObject;
                                            testedDataColumnKeys = (_.keys(testedDataColumnKeys));
                                        }

                                }

                                if (pluginParameterState?.isCommandFromExcel && pluginParameterState.isGoogleDriveFromExcel) {
                                    handleSendDataToExcel(finalData, isRunAndSave);
                                }

                                setState((prevState) => {
                                    return {
                                        ...prevState, testedDataList: finalData,
                                         testedDataColumnKeys: testedDataColumnKeys,
                                         dynamicColumnSchema: response?.data?.dynamicColumnSchema,
                                         nativeCollectionError: null
                                    }
                                });
                            }
                            catch(error){
                                console.log(error)
                                errorMessage = "The collection was tested successfully but data is not available for the given Data Json Path.";
                            }
                        }
                        else{
                            errorMessage = "The collection was tested successfully but data is not available for the given Data Json Path.";
                        }
                    }
                }
                setIsLoading(false);
                setErrorMessage(errorMessage,false);
        }
    }


    // sets error message
    const setErrorMessage = (errorMessage, isTestingConnection) => {
        setState((prevState) => {
            return {
                ...prevState, testCollectionError: errorMessage,
                isTestingConnection: isTestingConnection
            }
        });
    }

    const addNewDataCollection = () => {
        let dataCollectionModal = getDataCollectionModal();

        if (pluginParameterState?.isCommandFromExcel && pluginParameterState?.isEditMode) {
            executedData(true);
        }

        if (dataCollectionModal?.uId) {
            setIsLoading(true);
            const allColumns = state?.collectionColumnSchema?.filter(i => i.isSelected || i.isManuallyCreated);
            const columns = allColumns.map((i) => {
                const currentColl = dataCollectionModal.collectionColumns.filter(c => c.columnName == i.columnName);
                if (currentColl.length > 0) {
                    return {
                        collectionId: currentColl[0].collectionId,
                        columnName: currentColl[0].columnName,
                        dataType: currentColl[0].dataType,
                        dataTypeName: currentColl[0].dataTypeName,
                        displayFormat: currentColl[0].displayFormat,
                        displayName: currentColl[0].displayName,
                        id: currentColl[0].id,
                        isDefault: currentColl[0].isDefault,
                        isSortable: currentColl[0].isSortable,
                        isFilterable: currentColl[0].isFilterable,
                        notQuerable: currentColl[0].notQuerable,
                        uId: currentColl[0].uId,
                        displayOrder: i.displayOrder ?? 0,
                    }
                }
                else {
                    const matchingFormat = findDisplayFormat(i.dataTypeName,state);
                    return {
                        ...i,
                        displayOrder: i.displayOrder ?? 0,
                        displayFormat: isNullOrEmpty(i.displayFormat) ? (matchingFormat?.displayFormat ?? AppEnum.DefaultDisplayFormat.General) : i.displayFormat,
                        dataType: matchingFormat?.sysDataTypeId ?? 6
                    };
                }
            })

            dataCollectionModal.collectionColumns = columns;
            // dataCollectionModal.collectionParameters = searchOptionsParameters;
            if (dataCollectionModal.isCollectionAsDataSource) {
                if(variableUId.length > 0){
                    let updateUserModel = { ...UpdateUserModel };
                    updateUserModel.uId = variableUId;
                    updateUserModel.name = dataCollectionModal.name;
                    updateUserModel.description = "";
                    updateUserModel.sysDataTypeId = 8;
                    updateUserModel.complexTypeValue = JSON.stringify(isDynamicListValues);
                    dataCollectionModal.variable = updateUserModel;
                }
            }
            dataCollectionModal.deleteExistingColumns = true;

           updateDataCollection(dataCollectionModal);
        }
    }

    const updateDataCollection = (dataCollectionModal) => {

        collectionService.updateDataCollection(dataCollectionModal)
            .then(async (response) => {
                setIsLoading(false);
                if (response?.hasError) {
                    toast.error(response?.errorMessage);
                }
                else {
                    resetErrorMessages();
                    toast.success("Collection updated successfully.");
                    if (props.showNativeDataVisualizer) {
                        handleChangeObject();
                    }
                    else {
                        window.chrome?.webview?.postMessage('close_window');
                    }
                    const stateJson = JSON.stringify(state.collectionParameters)

                    const data = {
                        state: state?.uId,
                        code: stateJson
                    }

                    await setPluginChange(data);
                    
                    setTimeout(() => {
                        closeIFrameDialog('closeDialog');
                    }, 500);
                }

            })
    }

    const dataAfterTransformation = (testedDataList) => {

        let errorMessage = '';
        let transformedData = null;
        let testedDataTransformedColumnsKeys = null;

        if (testedDataList) {
            try {
                const dataTransformation = eval(`(${state.restDataTransformationScript})`);
                transformedData = dataTransformation(testedDataList);
            }
            catch (error) {
                setErrorMessage(error.message, false);
                return;
            }

            if (typeof transformedData === 'undefined') {
                setErrorMessage('The above Data Tranformation Script function did not return anything.', false);
                return;
            }

            let maxPropsObject = {};
            let maxPropsCount = 0;

            testedDataList.forEach(obj => {
                const numProps = Object.keys(obj).length;
                if (numProps > maxPropsCount) {
                    maxPropsCount = numProps;
                    maxPropsObject = obj;
                }
            });

            let collectionColumnsDataType = getDataTypeForObject(transformedData);

            testedDataTransformedColumnsKeys = transformedData[0];
            testedDataTransformedColumnsKeys = (_.keys(testedDataTransformedColumnsKeys));

            if(state?.sysCollectionTypeId === AppEnum.SysCollectionTypeId.REST){
                const restSchema = Object.keys(collectionColumnsDataType).map(key => ({
                    columnName: key,
                    columnDataType: collectionColumnsDataType[key],
                    displayName: key
                }));
                
                setRestSchemaList(restSchema);
            }

            var keys = state?.collectionColumnSchema ? state?.collectionColumnSchema?.filter(i => i.isDefault || i.isSelected).map(i => i.columnName) : testedDataTransformedColumnsKeys;
            removeEmptyRows(transformedData,keys);

            setState((prevState) => {
                return {
                    ...prevState,
                    testedDataTransformedList: transformedData,
                    testedDataTransformedColumneKeys: testedDataTransformedColumnsKeys
                }
            });
        }

        setErrorMessage(errorMessage, false);
    }

    const getType = (value) => {
        if (value === null) {
            return AppEnum.DataBaseDataType.String;
        }
        const type = Object.prototype.toString.call(value).slice(8, -1);
        if (type === AppEnum.DataBaseDataType.Number) {
            return Number.isInteger(value) ? AppEnum.DataBaseDataType.Int : AppEnum.DataBaseDataType.Long;
        }

        if (type === AppEnum.DataBaseDataType.String) {
            // Attempt to parse the value for various data types
            if (!isNaN(parseFloat(value)) && isFinite(value)) {
                return Number.isInteger(parseFloat(value)) ? AppEnum.DataBaseDataType.Int : AppEnum.DataBaseDataType.Long;
            }
            else if (!isNaN(Date.parse(value))) {
                const parsedDate = new Date(value);
                if (!isNaN(parsedDate.getTime())) {
                    if (value.includes("T")) {
                        return AppEnum.DataBaseDataType.DateTime;
                    } else {
                        return AppEnum.DataBaseDataType.Date;
                    }
                }
            }else if (/^\d+$/.test(value)) {
                const byteValue = parseInt(value);
                if (!isNaN(byteValue) && byteValue >= 0 && byteValue <= 255) {
                    return AppEnum.DataBaseDataType.Byte;
                }
            } else if (/^\$?[0-9]+(\.[0-9]{1,2})?$/.test(value)) {
                return AppEnum.DataBaseDataType.Currency;
            }
        }
        return type;
    };

    const removeEmptyRows = (flattenData, selectedColumns) => {
        if (flattenData == null || flattenData == undefined || selectedColumns == null || selectedColumns == undefined || selectedColumns.length == 0) {
          return;
        }
      
        try {
          const rowCount = flattenData.length;
      
          // List to store indices of rows to be removed
          const rowsToRemove = [];
      
          // Loop through each row (each item in the list is an object)
          for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
            let isRowEmpty = true;
            const row = flattenData[rowIndex];
      
            // Loop through the selected columns and check for empty values
            for (const column of selectedColumns) {
              // Skip checking for "RowIndex", "Level", or columns that contain "_ParentRowIndex"
              if (column === "RowIndex" || column === "Level" || column.includes("_ParentRowIndex")) {
                continue;
              }
      
              if (row.hasOwnProperty(column)) {
                // Check if the value is non-empty in the current column
                const value = row[column];
                if (value !== null && value !== undefined) {
                  isRowEmpty = false;
                  break;
                }
              }
            }
      
            // If the row is empty in all selected columns, mark it for removal
            if (isRowEmpty) {
              rowsToRemove.push(rowIndex);
            }
          }
      
          // Remove the identified rows from the flattenData (list of objects)
          for (const rowIndex of rowsToRemove.slice().reverse()) {
            flattenData.splice(rowIndex, 1);
          }
      
        // Adjust "RowIndex" property to be sequential, if it exists
        //   flattenData.forEach((row, index) => {
        //     if (row.hasOwnProperty("RowIndex")) {
        //       row["RowIndex"] = index + 1;  // Set RowIndex to be sequential starting from 1
        //     }
        //   });
        } catch (error) {
          return;
        }
    }

    const getDataTypeForObject = (data) => {
        const dataTypes = {};
        const keyValues = {};
        if (!data) return;

        if (state.collectionColumnSchema) {
            let obj = data[0];
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const value = obj[key];
                    if (state.collectionColumnSchema) {
                        const column = state.collectionColumnSchema.find(item => item.columnName === key);
                        dataTypes[key] = column ? column.columnDataType : getType(value);
                    }
                    else {
                        dataTypes[key] = getType(value);
                    }
                }
            }
        }
        else {
            [...data]?.reverse()?.forEach((row) => {
               
                for (const key in row) {
                    if (row.hasOwnProperty(key)) {
                        const value = row[key];
                        if (keyValues[key]) {
                            continue;
                        }
                        keyValues[key] = value;
                    }
                }
            });

            if (keyValues){
                for (const key in keyValues) {
                    if (keyValues.hasOwnProperty(key)) {
                        const value = keyValues[key];
                       
                        if (dataTypes[key]) {
                            continue;
                        }
                        dataTypes[key] = getType(value);
                    }
                }
            }
        }
        return dataTypes;
    };

    const onSearchHandler = (e) => {
        let searchedKey = e.target.value
        setSearchValue(searchedKey);
        resetErrorMessages();

        let filteredDataColunmList = [];
        let searchedColunmList = [];

        if (searchedKey) {
            filteredDataColunmList = columnsList;
            searchedColunmList = [];

            _.forEach(filteredDataColunmList, function (column) {
                if (_.includes(column?.displayName?.toLowerCase().trim(), searchedKey?.toLowerCase().trim()))
                    searchedColunmList.push(column);
            })
        }
        else{
            setSearchValue('');
            searchInputRef.current.value = '';
        }

        setFilterColumnsList(searchedColunmList);
    }

    const handleOnChangeSelectColumn = (event, index, item) => {

        var newSelectedList = [...columnsList]
        var newFilteredList = [...filterColumnsList]

        if (!preview) {
            // let hasColumnData = true;
            // if ((index == null || index == undefined) && !item && event.target.checked) {
            //     const selectedColumnNames = newSelectedList.map(column => column.columnName);

            //     const allColumnsPresent = selectedColumnNames.every(columnName => {
            //         return state?.testedDataList?.some(dataRow => columnName in dataRow);
            //     });
            
            //     hasColumnData = allColumnsPresent;
            // }
            // else {
            //     hasColumnData = item && state?.testedDataList?.some(data => Object.keys(data)?.includes(item?.columnName));
            // }

            // hasColumnData = !event.target.checked ? true : hasColumnData
            // setPreview(!hasColumnData);
            setPreview(true);
        }
        
        let originalIndex = null;
        if (newFilteredList?.length > 0){
            const columnInFilteredList = newFilteredList[index];
            originalIndex = newSelectedList?.findIndex(i => i.columnName  === columnInFilteredList?.columnName);
        }

        if (index == null || index == undefined) {
            if (event.target.checked) {
                newSelectedList = newSelectedList.map((i) => {
                    i.isSelected = true;
                    return i;
                })
            }
            else {
                newSelectedList = newSelectedList.map((i) => {
                    i.isSelected = false;
                    return i;
                })
            }
        }
        else {
            if (originalIndex && originalIndex != null){
                newSelectedList[originalIndex].isSelected = event.target.checked;    
            }else{
                newSelectedList[index].isSelected = event.target.checked;
            }
        }

        if (newFilteredList?.length > 0) {
            if (index == null || index == undefined) {
                if (event.target.checked) {
                    newFilteredList = newFilteredList.map((i) => {
                        i.isSelected = true;
                        return i;
                    })
                }
                else {
                    newFilteredList = newFilteredList.map((i) => {
                        i.isSelected = false;
                        return i;
                    })
                }
            }
            else {
                newFilteredList[index].isSelected = event.target.checked;
            }
            setFilterColumnsList(newFilteredList);
        }

        let maxDisplayOrder = Math.max(...newSelectedList.filter(i => i.isSelected).map(i => i.displayOrder || 0));
        if (maxDisplayOrder !== 0){
            let increment = 1;
            newSelectedList = newSelectedList.map(i => {                
                if (i.isSelected && (i.displayOrder == undefined || i.displayOrder == null)) {
                    const updatedColumn = { ...i, displayOrder: maxDisplayOrder + increment };
                    increment++;
                    return updatedColumn;
                }
                return i;
            });
        }

        setColumnList(newSelectedList);
        setIsColumnOrderChanged(false);
        setColumnList(newSelectedList);
        setState((prevState) => { return { ...prevState, collectionColumnSchema: newSelectedList } });

    }

    const getMergedCollectionsParameters = async (collectionUIdsToMerge, combineMergedParameters) => {
        try {
            const response = await collectionService.getMergeCollectionParameters(collectionUIdsToMerge);
            if (response?.hasError) {
                return [];
            }
            if (response?.data) {
                let result = response.data;
                if (combineMergedParameters) {
                    result =  _.uniqBy(response?.data, item => `${item.parameterTypeCD}_${item.parameterName}_${item.sysDataTypeId}`);
                }
                else {
                    result =  response?.data;
                    let updatedParams = [];
                    for (const collectionUId of collectionUIdsToMerge) {
                        const collectionResult = await collectionService.getCollectionDetails(collectionUId, true);
                        const collectionDetails = collectionResult?.data;

                        let collParams = result?.filter(i => i.childCollectionUId == collectionUId);
                        let updatedCollParams = collParams;
debugger
                        if (collectionDetails?.templateCollectionId) {
                            // collParams = cloudUpdateParameterValues(collParams, collectionDetails?.savedParameterValue, excelDataState);
                            collParams = cloudUpdateParameterValues(collParams, collectionDetails?.savedParameterValue, pluginParameterState);
                        }
                        else {
                            collParams = updateParameterValues(collParams);
                        }
                        updatedParams.push(...updatedCollParams);
                    }
                    result = updatedParams;
                }

                result?.forEach((params) => {
                    if (params?.sysDataTypeId == (AppEnum.DataTypeId.DynamicList || AppEnum.DataTypeId.List) && params?.childComplexTypeValue) {
                        params.complexTypeValue = params?.childComplexTypeValue;
                    }
                });
                return result;
            }
            return []; 
        } catch (error) {
            console.error("Error fetching merged collection parameters:", error);
            return [];
        }
    };

    const getMergedCollectionDetails = () => {

        collectionService.getAllCollections()
            .then((response) => {
                if (response?.hasError) {
                    setState((prevState) => { return { ...prevState, errorMessage: response?.errorMessage, } });
                }
                else if (response?.data) {
                    const usedCollections = response.data
                        .filter(item => state?.collectionUIdsToMerge.includes(item.uId))
                        .map(item => ({ ...item, isConnectionAuthorize: true })); 
                    setMergedCollectionsData(usedCollections)
                }
            })
    }
    

    const windowRef = useRef();

    useEffect(() => {
        const interval = setInterval(() => {
            if (openConnectionPopup) {
                getToken(selectedConnection, stateConnectionParameter, windowRef, setState,
                    openConnectionPopup, setOpenConnectionPopup, setIsAuthorizeAgain, executeData);
            }
        }, 3000);
        return () => clearInterval(interval);
    }, [openConnectionPopup])

    const handleAuthorizeAgain = async() =>{
        authorizeAgain(setState, selectedConnection, windowRef, setOpenConnectionPopup, setStateConnectionParameter);
    }

    const handleOpenDialog = (selectColumn) => {
        let column = state?.collectionColumns.find(i=> i?.columnName == selectColumn?.columnName);
        let matchFormat = false;
        if(!column){
            column = columnsList?.find(i=> i?.columnName == selectColumn?.columnName);
            matchFormat = true;
        }
        let defaultInfo = getEquivalentPriorityDataType(state?.displayFormatList, column?.dataTypeName);

        let matchDataType =  prioritizeEquivalentDataTypes.find(i=> i?.sysDataTypeId == column?.dataType);

        let dataType = matchDataType ? column?.dataType : defaultInfo?.sysDataTypeId;
        let displayFormatList = state?.displayFormatList.filter(i => i.sysDataTypeId == dataType);

        if(matchFormat || !matchDataType){                                                                                                                                                                                       
            let dataTypeCheck = displayFormatList?.find(i=> i.displayFormat == column.displayFormat);
            column.dataType = dataTypeCheck ? (column.dataType || defaultInfo?.sysDataTypeId) : defaultInfo?.sysDataTypeId;
            column.displayFormat = dataTypeCheck ? (column.displayFormat || defaultInfo?.displayFormat) : defaultInfo?.displayFormat;
        }
        setCustomColumn(column);
        setDatatypeDisplayFormate(displayFormatList);
        setOpenPopup(true);
    }

    const onDisplayNameChange = (value) => {
        setCustomColumn((prevstate) => { return { ...prevstate, displayName: value } });
    };

    const onListClick =(value, field)=>{
        if(field){
            let list = state?.displayFormatList.filter(i => i.sysDataTypeId == value);
            setDatatypeDisplayFormate(list);
            setCustomColumn((prevstate) => { return { ...prevstate, dataTypeName: list[0]?.dataBaseDataType, dataType: value, displayFormat: list[0]?.displayFormat } });
        }
        else {
            setCustomColumn((prevstate) => { return { ...prevstate, displayFormat: value } });
        }
    }

    const onSaveClick =() =>{
        let count = 0;
        let newDisplayName = formatDisplayName(customColumn?.displayName);

        _.forEach(columnsList, function (col) {
            if (col?.displayName?.toLowerCase().trim() === newDisplayName?.toLowerCase().trim() && 
                col?.columnName?.toLowerCase().trim() !== customColumn?.columnName?.toLowerCase().trim()) {
                count++;
            }
        })
        
        if(count > 0){
            toast.error("Duplicate display names are not permitted");
            return;
        }

        _.forEach(columnsList, function (col) {
            if (col?.columnName?.toLowerCase().trim() === customColumn?.columnName?.toLowerCase().trim()) {
                _.set(col, 'dataType', customColumn?.dataType);
                _.set(col, 'displayFormat', customColumn?.displayFormat);
                _.set(col, 'displayName', newDisplayName);
                _.set(col, 'dataTypeName', customColumn?.dataTypeName);
            }
        }) 
        _.forEach(state?.collectionColumns, function (col) {
            if (col?.columnName?.toLowerCase().trim() === customColumn?.columnName?.toLowerCase().trim()) {
                _.set(col, 'dataType', customColumn?.dataType);
                _.set(col, 'dataTypeName', customColumn?.dataTypeName);
                _.set(col, 'displayFormat', customColumn?.displayFormat);
                _.set(col, 'displayName', newDisplayName);
            }
        })
        setOpenPopup(false);
    }

    const handleClosePopup = () =>{
        setOpenPopup(false);
        setOpenDataScriptPopup(false);
    }

    const handleAddCloudDataScriptPopup = (scriptType, isOpenPopUp, isScriptAlreadyApplied) => { 
        setCloudDataScriptType(scriptType)
        if (isOpenPopUp) {
            setOpenDataScriptPopup(true);
        }
        if (isScriptAlreadyApplied) {
            handleTestScript(null, scriptType);
        }
    }

    const handleTestScript = (script, scriptType) => {
        try {
            const dataToTest = _.cloneDeep(state.testedDataList);
            let evalScript = null;

            // if ((cloudDataScriptType || scriptType) == AppEnum.DataScript.dataTransformationScript) {
            //     if (!script && state?.dataTransformationScriptId) {
            //         evalScript = preDefinedScriptsData?.find(i => i.id == state?.dataTransformationScriptId)?.script;
            //         if (!evalScript) return;
            //     }
            //     else {
            //         evalScript = script ? script : state.mergeScript; 
            //     }
            //     const dataTransformation = eval(`(${evalScript})`);
            //     let transformedData = dataTransformation(dataToTest);
    
            //     let testedDataTransformedColumnsKeys = transformedData[0];
            //     testedDataTransformedColumnsKeys = _.keys(testedDataTransformedColumnsKeys).filter(
            //         (key) => !key.endsWith("-style")
            //     );
    
            //     setTestedData((prevState) => { return { ...prevState, transformedData: transformedData, transformedDataColunmsKey: testedDataTransformedColumnsKeys } });
            // }
            if ((scriptType || cloudDataScriptType) == AppEnum.DataScript.dataStylingScript){
                if (!script && state?.dataStylingScriptId) {
                    evalScript = preDefinedScriptsData?.find(i => i.id == state?.dataStylingScriptId)?.script;
                    if (!evalScript) return;
                }
                else {
                    evalScript = script ? script : state.dataStylingScript; 
                }
                const dataTransformation = eval(`(${evalScript})`);
                let transformedData = dataTransformation(dataToTest);
    
                let testedDataTransformedColumnsKeys = transformedData?.[0];
                testedDataTransformedColumnsKeys = _.keys(testedDataTransformedColumnsKeys).filter(
                    (key) => !key.endsWith("-style")
                );
    
                if (!Array.isArray(transformedData)) {
                    toast.error("Warning: Transformed data is not an array.", transformedData);
                    return;
                }
                else if (Array.isArray(testedDataTransformedColumnsKeys) && transformedData?.length === 0) {
                    toast.error("Warning: Columns data is empty.");
                    return;
                }   
                setTestedData((prevState) => { return { ...prevState, styleTransformedData: transformedData, styleTransformedDataColunmsKey: testedDataTransformedColumnsKeys } });
    
            }
        } catch (error) {
            console.error("Syntax error in the script:", error.message);
            toast.error(error.message);
            return;
        }
    }

    const handleRemoveTransformation = (scriptType) => {
        if (scriptType == AppEnum.DataScript.dataTransformationScript) {
            setState((prevState) => { return { ...prevState, cloudDataTransformationScript: null } });
            setState((prevState) => { return { ...prevState, dataTransformationScriptId: null } });
            setTestedData((prevState) => { return { ...prevState, transformedData: [], transformedDataColunmsKey: [] } });
        }
        else {
            setState((prevState) => { return { ...prevState, dataStylingScript: null } });
            setState((prevState) => { return { ...prevState, dataStylingScriptId: null } });
            setTestedData((prevState) => { return { ...prevState, styleTransformedData: [], styleTransformedDataColunmsKey: [] } });
        }
        setMuiDialog(false);
        setCloudDataScriptType(null);
    }

    const getCollectionScripts = async () => {
        try {
            const response = await getAllScript(true);
            if (response?.data) {
                setPreDefinedScriptsData(response?.data);
                return response?.data;
            }
            return null; 
        } catch (error) {
            console.error("Error fetching collection scripts:", error);
            return null;
        }
    };
    const handleMergePopupClose = () => {
        setIsMergeDataPopupVisible(false);
        setMergeDataPopupMessage([]);
    }

    const handleSendDataToExcel= (response, isSaveAndRun) => {
        if (pluginParameterState?.isCommandFromExcel) {
            const responseData = pluginParameterState?.isMergeCollectionFromExcel ? response?.data?.data : response;
            //setExcelDataState((prevState) => { return { ...prevState, parameters: searchOptionsParameters, data: responseData } });
            let dtScript = state?.cloudDataTransformationScript
            let dsScript = state?.dataStylingScript
            if (state?.dataTransformationScriptId) {
                dtScript = preDefinedScriptsData?.find(i => i.id == state?.dataTransformationScriptId)?.script;
            }
            if (state?.dataStylingScriptId) {
                dsScript = preDefinedScriptsData?.find(i => i.id == state?.dataStylingScriptId)?.script;
            }
            if (!pluginParameterState?.isEditMode) {

                // handleChangeObject();
                sendDataToWPF({ parameters: searchOptionsParameters, data: responseData, columns: state?.collectionColumnSchema, CloudDTScript: dtScript, DSScript: dsScript });
            }

            if (isSaveAndRun) {
                sendDataToWPF({ parameters: searchOptionsParameters, data: responseData, columns: state?.collectionColumnSchema, CloudDTScript: dtScript, DSScript: dsScript });
            }
        }
    }

    const sendDataToWPF = (data) => {
        if (window.chrome && window.chrome.webview) {
            window.chrome.webview.postMessage(JSON.stringify({ type: "send_data_to_excel", data }));
        }
    }

    useEffect(() => {
        if (state?.mergeCollectionError === "Connection Establish") {
            executeData();
            setMergedCollectionsData(prevData =>
                prevData?.map(i => ({ ...i, isConnectionAuthorize: true }))
            );            
        }
    }, [state?.mergeCollectionError]);

    const confirmRemoveTransformation = (transforMationScriptType) =>{
        setCloudDataScriptType(transforMationScriptType);
        setMuiDialog(true);
    }

    return (
        <>
            <ColumnSelectionPopup
                columnsList={columnsList}
                rowData={state?.testedDataTransformedList}
                handleOnChangeSelectColumn={handleOnChangeSelectColumn}
                handleSave={addNewDataCollection}
                executeData={executeData}
                preview={preview}
                handleChangeObject={handleChangeObject}
                isLoading={isLoading}
                isDialogOpen={queryState?.CollectionUId ? false : isDialogOpen}
                state={state}
                setState={setState}
                selectedConnection={selectedConnection}
                onSearchHandler={onSearchHandler}
                searchInputRef={searchInputRef}
                searchValue={searchValue}
                setColumnList={setColumnList}
                setIsColumnOrderChanged={setIsColumnOrderChanged}
                handleSearchOptionsButtonClick={handleSearchOptionsButtonClick}
                selectedSearchButton={selectedSearchButton}
                isSearchOptionsAvailable={isSearchOptionsAvailable}
                searchOptionsParameters={searchOptionsParameters}
                setSearchOptionsParameters={setSearchOptionsParameters}
                executedData={executedData}
                isOpenInDialog={queryState?.CollectionUId ? false : isOpenInDialog}
                filterColumnsList={filterColumnsList}
                handleAuthorizeAgain={handleAuthorizeAgain}
                isAuthorizeAgain={isAuthorizeAgain}
                showNativeDataVisualizer={queryState?.CollectionUId ? true : props.showNativeDataVisualizer}
                handleOpenDialog ={handleOpenDialog}
                openPopup={openPopup}
                handleClosePopup={handleClosePopup}
                onListClick={onListClick}
                onSaveClick={onSaveClick}
                onDisplayNameChange={onDisplayNameChange}
                customColumn={customColumn}
                datatypeDisplayFormate={datatypeDisplayFormate}
                prioritizeEquivalentDataTypes={prioritizeEquivalentDataTypes}
                mergedCollectionsData={mergedCollectionsData}
                setMergedCollectionsData={setMergedCollectionsData}
                isMergeDataPopupVisible={isMergeDataPopupVisible}
                mergeDataPopupMessage={mergeDataPopupMessage}
                isMergeCancelledRef={isMergeCancelledRef}
                handleAddCloudDataScriptPopup={handleAddCloudDataScriptPopup}
                openDataScriptPopup={openDataScriptPopup}
                setCloudDataScriptType={setCloudDataScriptType}
                cloudDataScriptType={cloudDataScriptType}
                handleTestScript={handleTestScript}
                testedData={testedData}
                handleRemoveTransformation={handleRemoveTransformation}
                preDefinedScriptsData={preDefinedScriptsData}
                handleMergePopupClose={handleMergePopupClose}
                confirmRemoveTransformation={confirmRemoveTransformation}
                muiDialog={muiDialog}
                setMuiDialog={setMuiDialog}
                excelDataState={pluginParameterState}
                />
            {isDialogOpen &&
                <BasicInformationController
                    resetErrorMessages={resetErrorMessages}
                    state={state}
                    setState={setState}
                    prevStepRef={null}
                    setSelectedConnection={setSelectedConnection}
                    isDialogOpen={isDialogOpen}
                    setIsDialogOpen={setIsDialogOpen}
                    saveCollection={addNewDataCollection}
                    isBasicInfoSubmitted={true}
                    isUpdatingCollection={true}
                    isCloudLoading={isLoading}
                />}
        </>

    )

}